<i18n lang="yaml">
en:
  teaserButton1: 'Connect'
  teaserButton2: 'Knowledge Base'
  teaserLink: 'https://kb.selectel.com/25264466.html'
  sectionTitle1: 'Winner of the DCJournal.ru Award'
  sectionTitle2: 'Our clients about us'
  sectionSubtitle: 'Cloud powered by&nbsp;VMware won the DCJournal.ru national award in&nbsp;2019 in&nbsp;the Cloud of&nbsp;the Year category.'
  sectionImageAlt: 'DCJournal.ru Award'
  ctaTitle1: 'Build VMware-based infrastructure now'
  ctaTitle2: 'Not sure how to&nbsp;migrate your services to&nbsp;Selectel?'
  ctaDescription: 'We&nbsp;can help! We&rsquo;ll evaluate your project, draw up&nbsp;terms of&nbsp;reference, and migrate&nbsp;it.<br>We&rsquo;ll do&nbsp;it&nbsp;for free until August&nbsp;1, 2021.'
  ctaButton1: 'Create Virtual Machine'
  ctaButton2: 'Learn more about the promotion'
ru:
  teaserButton1: 'Подключиться'
  teaserButton2: 'База знаний'
  teaserLink: 'https://kb.selectel.ru/24388091.html'
  sectionTitle1: 'Обладатель премии «ЦОДы.РФ»'
  sectionTitle2: 'Клиенты о нас'
  sectionSubtitle: 'Облако на базе VMware в 2019 году получило национальную премию «ЦОДы.РФ» в&nbsp;номинации «Облако года».'
  sectionImageAlt: 'ЦОДы РФ'
  ctaTitle1: 'Постройте инфраструктуру на&nbsp;базе&nbsp;VMware уже&nbsp;сейчас'
  ctaTitle2: 'Не&nbsp;знаете, как перевезти свои сервисы в&nbsp;Selectel?'
  ctaDescription: 'Мы&nbsp;поможем&nbsp;&mdash; оценим проект, сформируем требования и&nbsp;осуществим перенос.<br>До 1&nbsp;августа&nbsp;2021 года сделаем это бесплатно.'
  ctaButton1: 'Создать виртуальную машину'
  ctaButton2: 'Узнать подробнее об акции'
</i18n>

<template>
  <div class="page">
    <teaser
      :title="pageTitle"
      :teaser="teaser"
      :svg-background="require('~/assets/images/components/teaser/background/cloud-vmware.svg?inline').default"
    >
      <template #buttons>
        <a
          href="https://my.selectel.ru/registration?destination=/vmware"
          class="btn btn--lg"
          v-html="$t('teaserButton1')"
        ></a>
        <a
          :href="$t('teaserLink')"
          class="btn btn--lg"
          v-html="$t('teaserButton2')"
        ></a>
      </template>
    </teaser>

    <product-reward
      :title="$t('sectionTitle1')"
      :description="$t('sectionSubtitle')"
      :image-src="require('~/assets/images/components/single/reward/reward.svg?inline').default"
      :image-alt="$t('sectionImageAlt')"
    ></product-reward>

    <products
      v-if="hasProducts"
      :products="products"
    ></products>

    <vmware-logo-cards
      v-if="hasLogoCards"
      :logo-cards="logoCards"
    ></vmware-logo-cards>

    <call-to-action
      v-lazy-background :lazy-background="require('~/assets/images/components/common/call-to-action/cloud-vmware-1.jpg')"
      :title="$t('ctaTitle1')"
    >
      <a
        href="https://my.selectel.ru/registration?destination=/vmware"
        class="btn btn--lg"
        v-html="$t('ctaButton1')"
      ></a>
    </call-to-action>

    <advantages
      v-if="hasAdvantages"
      :advantages="advantages"
    ></advantages>

    <s-section
      type="gray"
      :title="$t('sectionTitle2')"
    >
      <div class="row">
        <div class="col-xl-6 col-lg-8 mx-auto">
          <div class="embed-responsive embed-responsive--16by9">
            <iframe
              class="embed-responsive-item"
              width="560"
              height="315"
              src="https://www.youtube.com/embed/4Mic_2cQqPc"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </s-section>

    <call-to-action
      v-lazy-background :lazy-background="require('~/assets/images/components/common/call-to-action/cloud-vmware-2.jpg')"
      :title="$t('ctaTitle2')"
      :description="$t('ctaDescription')"
    >
      <nuxt-link
        :to="localePath('/onboarding/')"
        class="btn btn--lg"
        v-html="$t('ctaButton2')"
      ></nuxt-link>
    </call-to-action>

    <useful
      v-if="hasUseful"
      :useful="useful"
    ></useful>

    <form-request
      v-if="hasForm"
      :form="form"
    ></form-request>

    <faq
      v-if="hasFaq"
      :faq="faq"
    ></faq>
  </div>
</template>

<script>
import PageComponents from '~/mixins/page/page-components'
import PageSeo from '~/mixins/page/page-seo'

import Teaser from '~/components/teaser/Teaser'
import ProductReward from '~/components/single/cloud/ProductReward'
import Products from '~/components/common/products/Products'
import VmwareLogoCards from '~/components/single/vmware/VmwareLogoCards'
import CallToAction from '~/components/common/call-to-action/CallToAction'
import Advantages from '~/components/common/advantages/Advantages'
import Useful from '~/components/common/useful/Useful'
import FormRequest from '~/components/forms/FormRequest'
import Faq from '~/components/common/faq/Faq'

export default {
  async asyncData(ctx) {
    const {app, $http, error} = ctx

    try {
      const page = await $http.$get(`${app.wp}/v2/pages/slug/vmware`)

      return {page}
    } catch (err) {
      error(err)
    }
  },
  name: 'PageVmware',
  components: {
    Teaser,
    ProductReward,
    Products,
    VmwareLogoCards,
    CallToAction,
    Advantages,
    Useful,
    FormRequest,
    Faq
  },
  mixins: [
    PageComponents,
    PageSeo
  ],
  computed: {
    logoCards() {
      return this.page.acf.logoCards
    },
    hasLogoCards() {
      return !!this.page?.acf?.logoCards?.items
    }
  }
}
</script>